import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { useMe } from '../auth/useMe';
import { visibleSettingsSections } from './settings-sections';

/**
 * Sub-navigation of the settings area (spec 10 §6, style guide 2.14, 2.56, 2.71): from 1024 px the tab band
 * of every area the member's permissions show (`settings-sections.ts`); below 1024 px, where the bottom tab
 * bar replaces the sidebar, one link back to the overview `/settings` instead of a band of eleven tabs that
 * scrolls sideways (S150-7). Cosmetic, the server enforces the permission on each screen's own requests.
 * Each page renders it below its own `h1`.
 */
export function SettingsNav() {
  const { t } = useTranslation();
  const me = useMe();
  const sections = visibleSettingsSections(me.data?.active_tenant?.permissions ?? []);

  return (
    <>
      <Link to="/settings" className="ui-settings-back">
        <ArrowLeft aria-hidden="true" size={16} />
        {t('settings.overview.back')}
      </Link>
      <nav aria-label={t('settings.nav.ariaLabel')} className="ui-tabband ui-settings-tabs">
        {sections.map(({ key, path, icon: Icon, labelKey, end }) => (
          <NavLink key={key} to={path} end={end} className="ui-tabband__item">
            <Icon aria-hidden="true" className="ui-tabband__icon" />
            {t(labelKey)}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
